import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "seller-settings" }
const _hoisted_2 = { class: "settings-tabs" }
const _hoisted_3 = ["onClick"]

import { computed, markRaw, ref } from "vue";
  import { trans } from "@/utils/trans";
  import { Hotkeys, Interface, Labels } from "@/components/action-block/tabs/seller/settings";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Setting',
  setup(__props) {

  const activeTabKey = ref("interface");
  const activeTab = computed(() => tabs.value.find(({ key }) => key === activeTabKey.value));

  const tabs = ref([
    {
      label: trans("live.tabs.settings.interface_tab.label"),
      key: "interface",
      component: markRaw(Interface),
      class: "interface-settings"
    },
    {
      label: trans("live.tabs.settings.hotkeys_tab.label"),
      key: "hotkeys",
      component: markRaw(Hotkeys),
      class: "hotkeys-settings stage-b-item",
      tabClass: "stage-b-item",
    },
    {
      label: trans("live.tabs.settings.labels_tab.label"),
      key: "labels",
      component: markRaw(Labels),
      class: "labels-settings"
    }
  ]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          key: tab.key,
          class: _normalizeClass([[tab.tabClass || '', { active: tab.key === activeTabKey.value }], "settings-tab"]),
          onClick: ($event: any) => (activeTabKey.value = tab.key)
        }, _toDisplayString(tab.label), 11, _hoisted_3))
      }), 128))
    ]),
    (activeTab.value)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(activeTab.value.component), {
          key: 0,
          class: _normalizeClass(activeTab.value.class)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}
}

})